import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles((theme: Theme) => ({
  path: {
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.secondary.contrastText,
    textDecoration: 'none',
  },

  appIcon: {
    color: `${theme.palette.primary.main} !important`,
    width: '36px !important',
    height: '36px !important',
  },

  arrowDownIcon: {
    marginLeft: '2px',
    opacity: '0.6',
    cursor: 'pointer',
  },

  userDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,

    textAlign: 'right',
    fontWeight: '400',

    '& h1': {
      margin: 0,
      padding: 0,
      fontSize: '1rem',
      lineHeight: '1rem',
      color: '#191C1A',
    },

    '& span': {
      margin: 0,
      padding: 0,
      marginTop: '-0.25px',
      fontSize: '0.75rem',
      lineHeight: '1rem',
      color: '#5A5A63',
    },
  },

  helpIconBox: {
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    padding: '0.5rem',
    borderRadius: '100%',
    margin: '0',
    height: '40px',

    '&:hover': {
      backgroundColor: getRGBA(theme.palette.primary.main, 0.1),
    },
  },

  helpIcon: {
    margin: '0',
    padding: '0',
    opacity: '0.6',
    cursor: 'pointer',
  },
}))

export { useStyles }
